<template>
<div>
    <div class="d-flex flex-column-fluid">
        <!--begin::Container-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-lg-12 col-xl-12">
                            <div class="card card-custom gutter-b bg-transparent shadow-none border-0">
                                <div class="card-header align-items-center  border-bottom-dark px-0">
                                    <div class="card-title mb-0">
                                        <h3 class="card-label mb-0 font-weight-bold text-body">
                                            Список на складе
                                        </h3>
                                    </div>
                                     <div class="icons d-flex">
                                        <router-link to="/admin/add-stock" class="btn ml-2 p-0 kt_notes_panel_toggle" data-toggle="tooltip" title="" data-placement="right" data-original-title="Check out more demos" v-if="$parent.permissions.includes('stock-manage')">
                                            <span class="bg-secondary h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center  rounded-circle shadow-sm " v-on:click="
                                                display_form = !display_form
                                                ">
                                                <svg width="25px" height="25px" viewBox="0 0 16 16" class="bi bi-plus white" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
                                                </svg>
                                            </span>
                                        </router-link>
                                        <!-- <a href="#" onclick="printDiv()" class="ml-2">
                                            <span class="icon h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center rounded-circle ">
                                                <svg width="15px" height="15px" viewBox="0 0 16 16" class="bi bi-printer-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5z"></path>
                                                <path fill-rule="evenodd" d="M11 9H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"></path>
                                                <path fill-rule="evenodd" d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"></path>
                                                </svg>
                                            </span>
                                        </a> -->
                                        <a href="/api/admin/stock/download" class="ml-2" @click.prevent="downloadStocks()">
                                            <span class="icon h-30px font-size-h5 w-30px d-flex align-items-center justify-content-center rounded-circle ">
                                                <svg width="15px" height="15px" viewBox="0 0 16 16" class="bi bi-file-earmark-text-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7 2l.5-2.5 3 3L10 5a1 1 0 0 1-1-1zM4.5 8a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zM4 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"></path>
                                                </svg>
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 ">
                            <div class="card card-custom gutter-b bg-white border-0">
                                <div class="card-body">
                                    <div>
                                        <div class=" table-responsive" id="printableTable">

                                            <div id="sale_wrapper" class="dataTables_wrapper no-footer">

                                            <div class="dataTables_length" id="sale_length"><label>Показать
                                            <select name="sale_length"  class="" v-model="limit" v-on:change="fetchstocks()">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                            <option value="500">500</option>
                                            <option value="1000">1000</option>
                                            </select> записей</label></div>

                                            <div id="sale_filter" class="dataTables_filter d-flex">
                                                <div class="filters">
                                                    <label for="date_from">Дата создания:</label>
                                                    <input type="date" id="date_from" v-model="dateFrom" @change="fetchstocks()">
                                                    -
                                                    <input type="date" id="date_to" v-model="dateTo" @change="fetchstocks()">

                                                    <label for="stock_status" class="ml-3">Статус:</label>
                                                    <select id="stock_status" class="mr-3" v-model="stockStatus" @change="fetchstocks()">
                                                        <option value=""></option>
                                                        <option value="IN">IN</option>
                                                        <option value="OUT">OUT</option>
                                                    </select>
                                                </div>

                                                <label>Поиск:<input type="text" placeholder=""  v-model="searchParameter" @keyup="searchProducts()"></label>
                                                <button v-if="this.searchParameter != ''" @click="clearSearch">Очистить</button>
                                                </div>
                                                <table id="sale" class="display dataTable no-footer" sale="grid">
                                                    <thead class="text-body">
                                                        <tr sale="row">

<!--                                                            <th class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 53.1891px;" @click="sorting('id')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'id'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'id' ? 'sorting_desc' : 'sorting'">-->
<!--                                                                ID-->
<!--                                                            </th>-->

                                                           <th class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 53.1891px;" @click="sorting('created_at')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'created_at'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'created_at' ? 'sorting_desc' : 'sorting'">
                                                                Создан
                                                            </th>
                                                            <th class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 53.1891px;" @click="sorting('product_id')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'product_id'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'product_id' ? 'sorting_desc' : 'sorting'">
                                                                Товар
                                                            </th>
                                                            <th class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 53.1891px;" @click="sorting('product_id')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'product_id'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'product_id' ? 'sorting_desc' : 'sorting'">
                                                                SKU
                                                            </th>
                                                            <th class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 53.1891px;" @click="sorting('warehouse_id')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'warehouse_id'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'warehouse_id' ? 'sorting_desc' : 'sorting'">
                                                                Склад
                                                            </th>

                                                            <th class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 53.1891px;" @click="sorting('stock_status')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'stock_status'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'stock_status' ? 'sorting_desc' : 'sorting'">
                                                                Статус
                                                            </th>

                                                            <th class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 53.1891px;" @click="sorting('qty')" :class="(this.$data.sortType == 'asc' || this.$data.sortType == 'ASC') && this.$data.sortBy == 'qty'  ? 'sorting_asc' : (this.$data.sortType == 'desc' || this.$data.sortType == 'DESC') && this.$data.sortBy == 'qty' ? 'sorting_desc' : 'sorting'">
                                                                Количество
                                                            </th>


                                                            <th  class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 53.1891px;">
                                                                Тип/Причина
                                                            </th>

                                                            <th  class="no-sort sorting_disabled" rowspan="1" colspan="1" aria-label="Action" style="width: 53.1891px;">
                                                                Цена
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="kt-table-tbody text-dark">
                                                        <tr class="kt-table-row kt-table-row-level-0 odd" sale="row" v-for="stock in stocks" v-bind:key="stock.id">
<!--                                                            <td>-->
<!--                                                                {{ stock.id }}-->
<!--                                                            </td>-->
                                                            <td>
                                                                {{ stock.created_at }}
                                                            </td>

                                                            <td >
                                                                <router-link :to="'/admin/product/'+stock.product_id">{{  stock.product != null ? stock.product.detail != null ? stock.product.detail.length > 0 ? stock.product.detail[0].title : "" : "" :"" }}</router-link>
                                                            </td>
                                                            <td v-if="stock.product != null && stock.product_combination_id != null">
                                                                {{ getCombintationSku(stock.product, stock.product_combination_id) }}
                                                            </td>
                                                            <td v-else >
                                                                {{  stock.product != null ? stock.product.product_sku != null ?  stock.product.product_sku : "" :"" }}
                                                            </td>
                                                            <td>
                                                                {{ stock.warehouse ? stock.warehouse.warehouse_name : "" }}
                                                            </td>


                                                            <td>
                                                                {{ stock.stock_status }}
                                                            </td>
                                                            <td @dblclick="editStockQty(stock)" v-if="!stock.isEditing">
                                                                {{ stock.qty }}
                                                            </td>
                                                            <td v-else>
                                                                <input v-model="stock.qty" @blur="saveStockQty(stock)" @keyup.enter="saveStockQty(stock)" type="number" class="form-control bg-white" />
                                                            </td>

                                                            <td>
                                                                {{ stock.stock_type }}
                                                                <template v-if="stock.reference" >
                                                                    <router-link :to="redirectLinks[stock.stock_type] + stock.reference.id">
                                                                        #{{stock.reference.id}}
                                                                    </router-link>
                                                                </template>

                                                            </td>
                                                            <td v-if="stock.reference_price > 0">
                                                                {{ Number(stock.reference_price).toFixed(2) }}$
                                                            </td>
<!--                                                            <td v-else-if="stock.reference_price != null">-->
<!--                                                                {{ Number(stock.reference_price.price - (stock.reference_price.price * (stock.reference_price.discount / 100))).toFixed(2) }}{{ currencySymbol }}-->
<!--                                                            </td>-->
                                                            <td v-else>
                                                                {{ stock.product.product_price_with_vat }}$
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <ul class="pagination pagination-sm m-0 float-right">
                                                    <li v-bind:class="[{disabled: !pagination.prev_page_url}]"><button class="page-link" href="#" @click="fetchstocks(pagination.prev_page_url)">Предыдущая</button></li>

                                                    <li class="disabled">
                                                        <span class="page-link text-dark text-center" href="#">Стр {{ pagination.current_page }} из {{ pagination.last_page }}</span>
                                                        <span class="page-link text-dark">Перейти на <input style="width:25px;border:1px solid #dee2e6;text-align: center;" type="text" v-model="pagination.current_page" @keyup="changePage()" /></span>
                                                    </li>

                                                    <li v-bind:class="[{disabled: !pagination.next_page_url}]" class="page-item"><button class="page-link" href="#" @click="fetchstocks(pagination.next_page_url)">Следующая</button></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel" v-if="display_form" :class="display_form ? 'offcanvas-on' : ''">
        <div class="offcanvas-header d-flex align-items-center justify-content-between pb-3">
            <h4 class="font-size-h4 font-weight-bold m-0">Add sale</h4>
            <a href="#" class="btn btn-sm btn-icon btn-light btn-hover-primary kt_notes_panel_close" v-on:click="display_form = 0">
                <svg width="20px" height="20px" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                </svg>
            </a>
        </div>
        <form id="myform">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="text-dark">Название </label>
                        <input type="text" name="text" v-model="stock.name" class="form-control" />
                        <small class="form-text text-danger" v-if="errors.has('name')" v-text="errors.get('name')"></small>
                    </div>
                    <div class="form-group">
                        <label class="text-dark">Направление </label>
                        <select v-model="stock.direction">
                            <option value="ltr">LTR</option>
                            <option value="rtl">RTL</option>
                        </select>
                        <small class="form-text text-danger" v-if="errors.has('direction')" v-text="errors.get('direction')"></small>
                    </div>
                    <div class="form-group">
                        <label class="text-dark">Код </label>
                        <input type="text" name="text" v-model="stock.code" class="form-control" />
                        <small class="form-text text-danger" v-if="errors.has('code')" v-text="errors.get('code')"></small>
                    </div>
                    <div class="form-group">
                        <label class="text-dark">Каталог </label>
                        <input type="text" name="text" v-model="stock.directory" class="form-control" />
                        <small class="form-text text-danger" v-if="errors.has('directory')" v-text="errors.get('directory')"></small>
                    </div>
                    <div class="form-group">
                        <input type="checkbox" name="text" v-model="stock.is_default" id="is_default" class="form-check-input" />
                        <label class="text-dark" for="is_default">Установить по умолчанию </label>
                        <small class="form-text text-danger" v-if="errors.has('is_default')" v-text="errors.get('is_default')"></small>
                    </div>

                </div>
            </div>
            <button type="button" @click="addUpdatesale()" class="btn btn-primary">Подтвердить</button>
        </form>
    </div>
</div>
</template>

<script>
import ErrorHandling from "../../ErrorHandling";
export default {
    data() {
        return {
            display_form: 0,
            stocks:[],
            searchParameter: '',
            sortBy:'id',
            sortType:'DESC',
            limit: 10,
            error_message: '',
            edit: false,
            actions: false,
            pagination: {},
            request_method: "",
            is_default: "0",
            token: [],
            errors: new ErrorHandling(),
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
            timer: null,
            stockStatus: null,
            dateFrom: null,
            dateTo: null,
            redirectLinks: {
                'Order': '/admin/order/',
                'Purchase': '/admin/purchase-detail/',
                'PurchaseReturn': '/admin/purchase-detail/',
                'SaleReturn': '/admin/purchase-detail/'
            }
        };
    },

    computed: {
        currencySymbol() {
            return window.appConfig?.currencySymbol || '€';
        }
    },

    methods: {
        editStockQty(stock) {
            this.$set(stock, 'isEditing', true);
        },
        saveStockQty(stock) {
            this.$set(stock, 'isEditing', false);
            
            axios.put(`/api/admin/stock/${stock.id}`, {
                qty: stock.qty
            }, this.token)
            .then(res => {
                console.log('Quantity updated successfully', res.data);
            })
            .catch(error => {
                console.error('Error updating quantity', error);
            });
        },
        fetchstocks(page_url) {
            this.$parent.loading = true;
            let vm = this;
            page_url = page_url || "/api/admin/stock";
            var arr = page_url.split('?');

            if (arr.length > 1) {
                page_url += '&limit='+this.limit;
            }
            else{
                page_url += '?limit='+this.limit;
            }
            if(this.searchParameter != null){
                page_url += '&searchParameter='+this.searchParameter;
            }

            if (this.dateFrom) {
                page_url += `&date_from=${this.dateFrom}`;
            }
            if (this.dateTo) {
                page_url += `&date_to=${this.dateTo}`;
            }

            if (this.stockStatus) {
                page_url += `&stock_status=${this.stockStatus}`;
            }

            page_url += '&sortBy='+this.sortBy+'&sortType='+this.sortType;
            page_url +='&getProduct=1';
            page_url +='&getWarehouse=1';


            var responseData = {};

            axios.get(page_url, this.token).then(res => {
                this.stocks = res.data.data;
                vm.makePagination(res.data.meta, res.data.links);
            })
            .finally(() => (this.$parent.loading = false));
        },

        changePage(){
          if(this.timer){
              clearTimeout(this.timer);
          }
          this.timer = setTimeout(() => {
              if(this.pagination.current_page>this.pagination.last_page) {
                  this.pagination.current_page = this.pagination.last_page
              } else if(this.pagination.current_page<1 || isNaN(this.pagination.current_page)) {
                  this.pagination.current_page = 1
              }
              this.fetchstocks('/api/admin/stock?page='+this.pagination.current_page);
          }, 1000)
      },

        makePagination(meta, links) {
            let pagination = {
                current_page: meta.current_page,
                last_page: meta.last_page,
                next_page_url: links.next,
                prev_page_url: links.prev
            };

            this.pagination = pagination;
        },
        productNameBasedOnType(stock){
            if(stock.product.product_type === "simple"){
                return stock.product.detail[0].title;
            }
            if(stock.product.product_type === "variable"){
                var nameToReturn =stock.product.detail[0].title+"(";
                stock.product.combination_detail.forEach((element,i) => {
                    if(element.product_combination_id == stock.product_combination_id){
                        element.combination.forEach((result,j) => {
                            nameToReturn += result.variation.detail[0].name;
                            if(element.combination.length != j+1){
                                nameToReturn +=',';
                            }
                        })
                    }
                });
                nameToReturn +=")";
                return nameToReturn;
            }
        },
        sorting(sortBy){
            this.sortBy = sortBy;
            this.sortType = this.sortType == 'asc' || this.sortType == 'ASC' ? this.sortType='desc' : this.sortType = 'asc';
            this.fetchstocks();
        },
        clearSearch(){
            this.searchParameter = "",
            this.fetchstocks();
        },
        getCombintationSku(product, combination_id) {
            let combination = product.combination_detail.filter(item => item.product_combination_id == combination_id)
            return (combination[0])?combination[0].sku:product.product_sku;
        },
        searchProducts(){
            if(this.timer){
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.fetchstocks();
            }, 1000)
        },

        downloadStocks () {
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: 'blob'
            };
            axios.get("/api/admin/stock/download", config)
                .then(response => {

                    console.log(response);
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' }) // or  application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = 'stocks'
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)
        },

    },
    mounted() {

        var token = localStorage.getItem('token');
        this.token = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        this.fetchstocks();
    },
    props: ['loading'],
};
</script>
